import { useNavigate } from 'react-router';
import Stack from '@mui/material/Stack';
import { CountdownTile, GameParams } from '../../features/index.ts';
import Box from '@mui/material/Box';
import { Button } from '../../components/button/index.ts';
import { Path } from '../../assets/enums/index.ts';
import { gameParamsSx } from './styles.ts';

export const GamePage = () => {
  const navigate = useNavigate();
  return (
    <Stack height={'100%'}>
      <Box pl={12} pt={12}>
        <CountdownTile totalSeconds={60} />
      </Box>
      <Button onClick={() => navigate(Path.PostGame)}>Next Page</Button>

      <GameParams sx={gameParamsSx} />

    </Stack>
  );
};
